// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"532":"styles","678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"532":"634175abfe0a94b14a8f","678":"8175a4ade4d7f01e9236","883":"add0024bbbbc5001515f"}[chunkId] + ".js";
};